import { IRouteChild } from '@simac/ui';
import { RetourProcessRoute } from './process/process.routes';
import { RetourReceiveRoute } from './receive/receive.routes';

export const RetourRoute: IRouteChild[] = [
  {
    title: 'MENU.FIELDSUPPORT.RECEIVE',
    icon: 'far fa-arrow-down-to-line',
    route: RetourReceiveRoute,
  },
  {
    title: 'MENU.FIELDSUPPORT.PROCESS',
    icon: 'far fa-gears',
    route: RetourProcessRoute,
  },
];
